module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray-2ecacbd5d855bef05e15a1d8d119702b.png";